import { Router } from "aurelia-router";
import { RegexHelper } from "./regex-helper";

export class UrlHelper {

    public static insertURLParameter(url: string, parameter: string, value: string): string {
        parameter = encodeURI(parameter); value = encodeURI(value);

        const urlparts = url.split('?');
        const kvp = urlparts[1] ? urlparts[1].split('&') : [];

        let i = kvp.length; let x; while (i--) {
            x = kvp[i].split('=');

            if (x[0] == parameter) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }

        if (i < 0) { kvp[kvp.length] = [parameter, value].join('='); }

        //this will reload the page, it's likely better to store this until finished
        return urlparts[0] + "?" + kvp.join('&');
    }

    public static removeURLParameter(url: string, parameter: string): string {
        //prefer to use l.search if you have a location/link object
        const urlparts = url.split('?');
        if (urlparts.length >= 2) {

            const prefix = parameter + '=';
            const pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (let i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }

    public static getQueryString(dictionary: any) {
        let str = "";
        for (const key in dictionary) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(dictionary[key]);
        }
        return str;
    }
 
    public static getQueryStringAsObject(): any {
        try {
            const params = new URLSearchParams(location.search.split('?')[1])
            const obj: any = {}
            for (const key of params.keys()) {
                obj[key] = params.get(key);
            }
            return obj;
        } catch (e) {
            return {};
        }
    }

    public static getParameterValueByKey(key: string, url: string = null): string {
        if (!url) {
            url = window.location.href;
        }

        key = RegexHelper.escapeSquareBrackets(key);
        let regexExp = '[?&]' + key + '(=([^&#]*)|&|#|$)';
        if (key.toLocaleLowerCase() == 'referrer') regexExp = '[?]' + key + '(=([^#]*)|&|#|$)';

        const regex = new RegExp(regexExp, 'i'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    public static goToUrlFragment(router: Router, urlFragment: string) {
        const origin = location.origin + (router.options.root ? router.options.root : "");
        urlFragment = urlFragment.replace(origin, '');
        const href = decodeURIComponent(urlFragment);
        location.href = (router.options.root ? router.options.root : "") + href;
    }

    public static updateURL(queryDictionaryToUpsert: { [key: string]: any }, keysToRemove: string[], replace: boolean = false) {
        if (history.pushState) {
            let url = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
            const keys = Object.keys(queryDictionaryToUpsert);
            keys.forEach(key => {
                url = UrlHelper.removeURLParameter(url, key);
                if (queryDictionaryToUpsert[key]) {
                    url = UrlHelper.insertURLParameter(url, key, queryDictionaryToUpsert[key].toString());
                }
            });
            keysToRemove.forEach(key => {
                url = UrlHelper.removeURLParameter(url, key);
            });
            if (replace) {
                window.history.replaceState({ path: url }, '', url);
            } else {
                window.history.pushState({ path: url }, '', url);
            }
            return url;
        }
        return null;
    }

    public static getReferrer() {
        // Get the value of the "referrer" query parameter
        const referrerQueryParam = this.getQueryStringAsObject()?.referrer;

        return referrerQueryParam;
    }

    public static redirectForPasswordExpiry() {
        const referrer = UrlHelper.getReferrer();
        const referrerQueryString = '&referrer=' + (referrer ? referrer : location.href);                            
        location.href = '/resetpassword?passwordexpired=true' + referrerQueryString;
    }
}
